/**
 * Official Sell It Off ops contact identifiers.
 * Prefer importing from here instead of hardcoding E.164 / t.me links in feature modules.
 */

export const SELL_IT_OFF_OPS_WHATSAPP_E164 = "2348125554459";

/** Public Telegram username link (preferred for share/copy). */
export const SELL_IT_OFF_OPS_TELEGRAM_URL = "https://t.me/sellitoffnow";

/** Telegram deep link by phone (same ops number as WhatsApp). */
export const SELL_IT_OFF_OPS_TELEGRAM_PHONE_URL = "https://t.me/+2348125554459";

export function sellItOffOpsWhatsappUrl(prefill?: string): string {
  const text = prefill?.trim();
  if (!text) {
    return `https://wa.me/${SELL_IT_OFF_OPS_WHATSAPP_E164}`;
  }
  return `https://wa.me/${SELL_IT_OFF_OPS_WHATSAPP_E164}?text=${encodeURIComponent(text)}`;
}

/** Default public Telegram profile for ops / support. */
export function sellItOffOpsTelegramUrl(): string {
  return SELL_IT_OFF_OPS_TELEGRAM_URL;
}
